export default () => ({
    flow: sessionStorage.getItem('profile-flow') || 'completed'
})